import { IPromise, isFunction } from "angular";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isPromiseLike = (obj: any): obj is IPromise<unknown> => obj && isFunction(obj.then) && isFunction(obj.catch) && isFunction(obj.finally);
